import React from 'react';
import { connect } from 'react-redux';
import { provideLocalizationService, provideIntlService, registerForLocalization, registerForIntl } from '@progress/kendo-react-intl';
import { DateFormatter, EmptyFormatter, Grid, InlineBadge } from '../../shared/components';
import { getGeneralCompetencyStatusThemeColor } from '../../../resources/generalCompetencyStatus';
import { findStudentHours, sortStudentHours } from '../actions/student-overview-page-actions';

class StudentHoursList extends React.PureComponent {
  constructor() {
    super();
    this.handlePageChange = this.handlePageChange.bind(this);
    this.handleSort = this.handleSort.bind(this);
  }

  async componentDidMount() {
    if (this.props.studentId) {
      await this.props.findStudentHours({ studentId: this.props.studentId });
    }
  }

  render() {
    const localizationService = provideLocalizationService(this);
    const intlService = provideIntlService(this);
    return (
      <Grid
        loading={this.props.loading}
        data={this.props.hours}
        skip={this.props.skip}
        take={this.props.take}
        total={this.props.total}
        sort={this.props.sorting}
        onSortChange={this.handleSort}
        onPageChange={this.handlePageChange}
        columns={[
          {
            field: 'sessionName',
            className: 'align-left',
            headerClassName: 'align-left',
            title: localizationService.toLanguageString('studentHours.sessionName'),
            sortable: false
          },
          {
            field: 'occurredAt',
            title: localizationService.toLanguageString('studentHours.occurredAt'),
            width: '140px',
            cell: (e) => (
              <td>{EmptyFormatter(DateFormatter(e.dataItem.occurredAt, intlService))}</td>
            )
          },
          {
            field: 'minutes',
            title: localizationService.toLanguageString('studentHours.minutes'),
            width: '120px'
          },
          {
            field: 'sourceType',
            className: 'align-left',
            headerClassName: 'align-left',
            title: localizationService.toLanguageString('studentHours.sourceType'),
            sortable: false,
            width: '200px'
          },
          {
            field: 'status',
            title: localizationService.toLanguageString('studentHours.status'),
            width: '160px',
            cell: (e) => (
              <td className={e.className}>
                <InlineBadge themeColor={getGeneralCompetencyStatusThemeColor(e.dataItem.statusCode)}>
                  {e.dataItem.status}
                </InlineBadge>
              </td>
            )
          }
        ]}
      />
    );
  }

  async handlePageChange(e) {
    await this.props.findStudentHours({
      studentId: this.props.studentId,
      skip: e.page.skip,
      take: e.page.take
    });
  }

  handleSort(e) {
    this.props.sortStudentHours({ studentId: this.props.studentId, sort: e.sort });
  }
}

const mapStateToProps = state => ({
  loading: state.studentOverviewPage.hoursLoading,
  hours: state.studentOverviewPage.hours,
  skip: state.studentOverviewPage.skip,
  take: state.studentOverviewPage.take,
  total: state.studentOverviewPage.total,
  sorting: state.studentOverviewPage.sorting
});

const mapDispatchToProps = dispatch => ({
  findStudentHours: (payload) => dispatch(findStudentHours(payload)),
  sortStudentHours: (payload) => dispatch(sortStudentHours(payload))
});

registerForLocalization(StudentHoursList);
registerForIntl(StudentHoursList);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StudentHoursList);
